import { render, staticRenderFns } from "./template-props-select-dialog.vue?vue&type=template&id=e5aea15a&scoped=true&"
import script from "./template-props-select-dialog.vue?vue&type=script&lang=js&"
export * from "./template-props-select-dialog.vue?vue&type=script&lang=js&"
import style0 from "./template-props-select-dialog.vue?vue&type=style&index=0&id=e5aea15a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aea15a",
  null
  
)

export default component.exports